var $7494636cfae1f749$exports = {};
$7494636cfae1f749$exports = {
    "colorFormat": `\u{39C}\u{3BF}\u{3C1}\u{3C6}\u{3AE} \u{3C7}\u{3C1}\u{3CE}\u{3BC}\u{3B1}\u{3C4}\u{3BF}\u{3C2}`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$7494636cfae1f749$exports as default};
//# sourceMappingURL=el-GR.mjs.map
